export default __webpack_public_path__ + "static/media/1.ada887a0.jpg";